export default __webpack_public_path__ + "static/media/Pretendard-Regular.subset.876e22b0.woff2";